import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { PartyProps, JobworkProps, OrderPartyProps } from "../../types/jobwork";
import { GET } from "../../services/axios.service";

export interface NewOrderState {
  parties: PartyProps[];
  orderParties: OrderPartyProps[];
  jobworks: JobworkProps[];
  loading: boolean;
  error: string | null;
}

const initialState: NewOrderState = {
  parties: [],
  orderParties: [],
  jobworks: [],
  loading: false,
  error: null,
};

type FetchPartiesDataProps = {
  type: number;
};

export const fetchPartiesData = createAsyncThunk(
  "fetchPartiesDataForJobwork",
  async (req: FetchPartiesDataProps) => {
    let response: any;
    await GET(`/v1/worker/jobworks-parties`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const fetchOrderPartiesData = createAsyncThunk(
  "fetchOrderPartiesDataForJobwork",
  async () => {
    let response: any;
    await GET(`/v1/worker/order-parties`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const newJobworkSliceSlice = createSlice({
  name: "newJobworkSlice",
  initialState,
  reducers: {
    updateJobworksData: (state, action: PayloadAction<JobworkProps[]>) => {
      state.jobworks = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPartiesData.pending, (state, action: any) => {
      state.parties = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchPartiesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.parties = action.payload.data.data;
        state.error = null;
      } else {
        state.parties = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchPartiesData.rejected, (state, action: any) => {
      state.parties = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });

    builder.addCase(fetchOrderPartiesData.pending, (state, action: any) => {
      state.orderParties = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchOrderPartiesData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload.data.status === "success") {
        state.orderParties = action.payload.data.data;
        state.error = null;
      } else {
        state.orderParties = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchOrderPartiesData.rejected, (state, action: any) => {
      state.orderParties = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { updateJobworksData } = newJobworkSliceSlice.actions;

export const getParties = (state: RootState) => state.newJobwork.parties;

export const getJobworks = (state: RootState) => state.newJobwork.jobworks;

export const getOrderParties = (state: RootState) =>
  state.newJobwork.orderParties;

export default newJobworkSliceSlice.reducer;
